module.exports = __webpack_public_path__ + "assets/img/al1b.42701aa3.jpg";